import { useDependencies } from '@servicetitan/react-ioc';
import { SETTINGS_STORE_TOKEN } from '../stores/settings.store';

export const useSettingsStore = () => {
    const [settingsStore] = useDependencies(SETTINGS_STORE_TOKEN);
    return settingsStore;
};
